/**
 * TNCY-5 — TanStack Query keys for the Partner Companies feature.
 *
 * Per `tanstack-query-conventions` — narrow, hierarchical keys so an
 * invalidation targets the smallest slice that matters. Invitations and
 * links are separate sub-trees because they refetch independently.
 */
export const tenancyKeys = {
  all: ["tenancy"] as const,

  /** All of the caller's links (active + suspended) — Partner Companies. */
  links: () => [...tenancyKeys.all, "links"] as const,

  /** Outstanding invitations issued by the caller. */
  invitations: () => [...tenancyKeys.all, "invitations"] as const,

  /** TNCY-6 — the caller's active known-tenants set (picker source, XT-D26). */
  knownTenants: () => [...tenancyKeys.all, "known-tenants"] as const,

  /** TNCY-6 — cross-tenant access grants on one project (XT-D20/D22). */
  accessGrants: (projectId: string) =>
    [...tenancyKeys.all, "access-grants", projectId] as const,

  /** TNCY-6 — assignable users across granted tenants on one project (XT-D9). */
  assignableUsers: (projectId: string) =>
    [...tenancyKeys.all, "assignable-users", projectId] as const,

  /** PM-D39 — the caller tenant's admin-policy settings (max AI models, …). */
  settings: () => [...tenancyKeys.all, "settings"] as const,
};
